import {
    GET_FOLLOWUP_REMINDER_LIST,
    GET_FOLLOWUP_REMINDER_LIST_SUCCESS,
    GET_FOLLOWUP_REMINDER_LIST_FAIL,
    UPDATE_FOLLOWUP_REMINDER,
    UPDATE_FOLLOWUP_REMINDER_SUCCESS,
    UPDATE_FOLLOWUP_REMINDER_FAIL,
  } from "../actions/FollowUpRemindertypes"
  
  const initialState = {
    loading: false,
    data: [],
    error: null,
    updating: false,
    updateError: null,
  }
  
  export default function followUpReminderReducer(state = initialState, action) {
    switch (action.type) {
      case GET_FOLLOWUP_REMINDER_LIST:
        return {
          ...state,
          loading: true,
          error: null,
        }
      case GET_FOLLOWUP_REMINDER_LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
        }
      case GET_FOLLOWUP_REMINDER_LIST_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        }
      case UPDATE_FOLLOWUP_REMINDER:
        return {
          ...state,
          updating: true,
          updateError: null,
        }
      case UPDATE_FOLLOWUP_REMINDER_SUCCESS:
        return {
          ...state,
          updating: false,
          // Optionally update the specific item in the data array
          data: state.data.map((item) =>
            item.reminder_id === action.payload.reminderId ? { ...item, reminder_status: action.payload.status } : item,
          ),
        }
      case UPDATE_FOLLOWUP_REMINDER_FAIL:
        return {
          ...state,
          updating: false,
          updateError: action.payload,
        }
      default:
        return state
    }
  }
  